<template>
	<div class="payment-systems">
		<button class="payment-systems__btn btn btn--white" v-if="isMob && showCryptoTypes" @click="showCryptoTypes = false">
			Вернуться назад
		</button>

		<div class="payment-systems__label">
			Выберите платежную систему
		</div>
		<div class="payment-systems__items">
			<div class="payment-systems__item" v-for="type in showCryptoTypes ? cryptoItems : defaultItems" :key="type.id">
				<div class="payment-systems__item-logo" @click="setType(type)"
				:class="[selectedType && selectedType.id === type.id ? ['active'] : '']">
					<span v-if="type.caption" class="payment-systems__item-caption">{{ type.caption }}</span>
					<img :src="type.icon" class="payment-systems__item-img" />
				</div>
				<small v-if="showCryptoTypes" class="payment-systems__item-text">{{type.title}}</small>
			</div>
			<div class="payment-systems__item" v-if="isMob && !showCryptoTypes && cryptoItems?.length">
				<div class="payment-systems__item-logo btn--deposit" @click="showCryptoTypes = true">
					<img :src="cryptoImg" class="payment-systems__item-img">
				</div>
			</div>
		</div>

		<div class="payment-systems__items" v-if="!isMob">
			<div class="payment-systems__item" v-for="type in cryptoItems">
				<div :key="type.id" class="payment-systems__item-logo" @click="setType(type)" :class="[selectedType && selectedType.id === type.id ? ['active'] : '']">
					<img :src="type.icon" class="payment-systems__item-img">
				</div>
				<small class="payment-systems__item-text">{{type.title}}</small>
			</div>
		</div>
</div>

</template>

<script>

import breakpointsMixin from '../../mixins/breakpoints-mixin.vue';

export default {
	emits: [
		'set-type'
	],

	mixins: [
		breakpointsMixin
	],

	props: {
		items: {
			type: Array,
			default: null
		},

		selectedType: {
			type: [Object, Boolean],
			default: null
		}
	},

	data() {
		return {
			showCryptoTypes: false,
			cryptoImg: 'images/cryptos.svg'
		}
	},

	computed: {
		defaultItems() {
			return this.items.filter(type => type.group_code !== 'crypto');
		},

		cryptoItems() {
			return this.items.filter(type => type.group_code === 'crypto');
		}
	},

	watch: {
		isTablet(state) {
			if (!state) this.showCryptoTypes = false;
			if (state) this.setDefaultType();
		},

		showCryptoTypes() {
			this.setDefaultType()
		}
	},

	methods: {
		setType(type) {
			this.$emit('set-type', type)
		},

		setDefaultType() {
			if (this.isTablet) {
				this.$emit('set-type', this.showCryptoTypes ? null : (this.defaultItems?.find(item => item.code === 'card_p2p' ) || this.defaultItems[0]))
			}
		}
	}
}

</script>